<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane name="first" label="活动列表">

                            <el-form>
                                <el-form-item>
                                    <el-button type="primary" @click="addActivityDialogShow">开启活动</el-button>
                                </el-form-item>
                            </el-form>

                            <el-table :data="dataHandled" border style="width: 100%"
                                      :default-sort="{prop: 'id'}">
                                <el-table-column v-for="(header,index) in tableHeaders" :label="header.label"
                                                 :prop="header.text"
                                                 :key="index" width="150">
                                    <template slot-scope="scope">
                                        <!--<el-tooltip placement="top-end" v-for="(value,key) in scope.row" :key="key" v-if="key == header.text && ((key == 'gain_base_desc' && tableName == 'origin_footing_stone_config') || (key == 'requirement_desc' && tableName == 'ancient_gene_config') || (key == 'name') || (key == 'description'))">-->
                                            <!--<div slot="content">{{$t(value)}}</div>-->
                                            <!--<el-button type="text">{{value}}</el-button>-->
                                        <!--</el-tooltip>-->
                                        <span v-for="(value,key) in scope.row" v-if="key == header.text && key !== 'gain_base_desc' && key !== 'requirement_desc' && key !== 'name' && key !== 'description' && key !== 'switch_flag' && key !== 'stime' && key !== 'etime'">{{value}}</span>
                                        <span v-for="(value,key) in scope.row" v-if="key == header.text && key == 'template_id'">
                                            <span v-for="templateItem in activityTemplateData" v-if="templateItem.id == value">({{$t(templateItem.name)}})</span>
                                        </span>
                                        <div v-for="(value,key) in scope.row" v-if="key == header.text && key == 'switch_flag'">
                                            <div v-if="value == 1">
                                                <el-button style="color: red;" type="text" v-if="(new Date().getTime()) >= (new Date(scope.row.stime).getTime()) && (new Date().getTime()) <= (new Date(scope.row.etime).getTime())" @click="switchFlagActivity(scope.row)">关闭活动</el-button>
                                                <span v-if="(new Date().getTime()) > (new Date(scope.row.etime).getTime())">已过期活动</span>
                                                <el-button style="color: red;" type="text" v-if="(new Date().getTime()) < (new Date(scope.row.stime).getTime())" @click="switchFlagActivity(scope.row)">关闭活动</el-button>
                                            </div>

                                            <div v-if="value == 0">
                                                <el-button type="text" v-if="(new Date().getTime()) >= (new Date(scope.row.stime).getTime()) && (new Date().getTime()) <= (new Date(scope.row.etime).getTime())" @click="switchFlagActivity(scope.row)">开放活动</el-button>
                                                <span v-if="(new Date().getTime()) > (new Date(scope.row.etime).getTime())">已过期活动</span>
                                                <el-button type="text" v-if="(new Date().getTime()) < (new Date(scope.row.stime).getTime())" @click="switchFlagActivity(scope.row)">开放活动</el-button>
                                            </div>

                                            <div v-if="value == -1">
                                                <span>常驻活动</span>
                                            </div>
                                        </div>
                                        <span v-for="(value,key) in scope.row" v-if="key == header.text && key == 'stime'">
                                            <span v-if="value == -1">长期开启</span>
                                            <span v-else>{{value}}</span>
                                        </span>
                                        <span v-for="(value,key) in scope.row" v-if="key == header.text && key == 'etime'">
                                            <span v-if="value == -1">长期开启</span>
                                            <span v-else>{{value}}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="pagination">
                                <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                               :page-size="pageSize"
                                               layout="total, prev, pager, next, jumper" :total="totalRow">
                                </el-pagination>
                            </div>

                            <el-dialog title='开启活动' :visible.sync="addActivityShow" width="50%" lock-scroll center>
                                <div>
                                    <el-form :model="createActivityForm" label-width="100px">
                                        <el-form-item label="模板id:">
                                            <el-select v-model="createActivityForm.templateId">
                                                <el-option v-for="item in activityTemplateData" :key="item.id"
                                                           :label="item.id + '(' + $t(item.name) + ')'"
                                                           :value="item.id"
                                                           :disabled="item.select_tag == 0?true:false">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="全服开关:">
                                            <el-switch
                                                v-model="isSelectAllServer"
                                                active-color="#13ce66"
                                                inactive-color="#ff4949"
                                                active-text="全服"
                                                inactive-text="选服"
                                                :active-value="true"
                                                :inactive-value="false">
                                            </el-switch>
                                        </el-form-item>
                                        <el-form-item label="服务器id:" v-if="!isSelectAllServer">
                                            <el-select v-model="serverIds" multiple>
                                                <el-option v-for="item in serverGameList" :key="item.id"
                                                           :label="item.server_number + '(' + item.server_name + ')'"
                                                           :value="item.server_number">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="开关:">
                                            <el-switch
                                                v-model="createActivityForm.switchFlag"
                                                active-color="#13ce66"
                                                inactive-color="#ff4949"
                                                :active-value="1"
                                                :inactive-value="0">
                                            </el-switch>
                                            <div style="color: red">关闭表示就算开放时间也是关闭状态</div>
                                        </el-form-item>
                                        <el-form-item label="备注:">
                                            <el-input v-model="createActivityForm.memoBackup"></el-input>
                                            <div style="color: red">策划自行记录，前端不展示</div>
                                        </el-form-item>
                                        <el-form-item label="时间:">
                                            <el-date-picker v-model="dateTime" type="datetimerange" range-separator='至'
                                                            start-placeholder='开始时间' end-placeholder='结束时间' value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-form>
                                </div>

                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="addActivityShow = false">取消</el-button>
                                    <el-button type="primary" @click="confirmAddActivity">确认</el-button>
                                </div>
                            </el-dialog>
                        </el-tab-pane>
                        <el-tab-pane name="second" label="活动日历查看">
                            <el-card>
                                <el-calendar>
                                    <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
                                    <template
                                        slot="dateCell"
                                        slot-scope="{date, data}">
                                        <div :class="data.isSelected ? 'is-selected' : ''">
                                            {{ data.day.split('-').slice(1).join('-') }}
                                            <!--<span v-for="(item,index) in tableRawData" v-if="item.stime!== -1 && item.etime!== -1 && Date.parse(item.stime.split(' ')[0]) <= Date.parse(data.day) && Date.parse(item.etime.split(' ')[0]) >= Date.parse(data.day)">-->
                                                <!--<el-popover-->
                                                    <!--placement="right"-->
                                                    <!--width="400"-->
                                                    <!--trigger="click">-->
                                                  <!--<div v-for="i in activityDetailData">-->
                                                      <!--{{i.id}}({{i.memo_backup}})-->
                                                      <!--<span v-if="Date.parse(data.day) == Date.parse(i.stime.split(' ')[0])">今日开启</span>-->
                                                      <!--<span v-if="Date.parse(data.day) == Date.parse(i.etime.split(' ')[0])">今日结束</span>-->
                                                  <!--</div>-->
                                                    <!--<el-button slot="reference" type="text" icon="el-icon-info" @click="activityDetailShow(data.day)"></el-button>-->
                                                <!--</el-popover>-->
                                            <!--</span>-->

                                            <span v-for="(item,index) in tableRawData" v-if="item.stime!== -1 && item.etime!== -1 && Date.parse(item.stime.split(' ')[0]) <= Date.parse(data.day) && Date.parse(item.etime.split(' ')[0]) >= Date.parse(data.day)">
                                                <div style="margin-bottom: 5px;">
                                                    <div style="font-size: 4px;">
                                                        <span>{{item.id}}({{item.memo_backup}})</span>
                                                        <span v-if="Date.parse(data.day) == Date.parse(item.stime.split(' ')[0]) && Date.parse(data.day) !== Date.parse(item.etime.split(' ')[0])">今日开启</span>
                                                        <span v-if="Date.parse(data.day) == Date.parse(item.etime.split(' ')[0])">今日结束</span>
                                                    </div>
                                                    <div style="font-size: 4px;" v-if="(Date.parse(data.day) - Date.parse(item.stime.split(' ')[0]) <= 86400000) || (Date.parse(item.etime.split(' ')[0])) - Date.parse(data.day) <= 86400000">
                                                    ({{item.stime.split(' ')[0].split('-')[1] + '-' + item.stime.split(' ')[0].split('-')[2] + ' ' + item.stime.split(' ')[1].split(':')[0] + ':' + item.stime.split(' ')[1].split(':')[1]}}
                                                    to
                                                    {{item.etime.split(' ')[0].split('-')[1] + '-' + item.etime.split(' ')[0].split('-')[2] + ' ' + item.etime.split(' ')[1].split(':')[0] + ':' + item.etime.split(' ')[1].split(':')[1]}})
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </template>
                                </el-calendar>
                            </el-card>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </section>
        </div>
    </el-card>
</template>

<script>
   import {
       mapState
   } from 'vuex';
   import confApi from '../../service/conf_api'
   import activityApi from '../../service/activity_api'
   import worldApi from '../../service/world_api'
   import gameApi from '../../service/game_api'
   import loginApi from '../../service/login_api'
   import actionConfirm from '../../mixins/action_confirm'
   import paginationController from '../../mixins/pagination'
   import Utils from '../../lib/utils'

    export default {
        name: "activityConfig",
        data() {
            return {
                title: this.$route.meta.title,
                calendarShow: false,
                activeName: 'first',

                // 动态表头
                tableHeaders: [],
                // 表数据
                tableRawData: [],
                tableTotalRow: '',
                addActivityShow: false,
                activityTemplateData: [],

                createActivityForm: {
                    templateId: '',
                    serverids: '',
                    switchFlag: 0,
                    memoBackup: '',
                    stimeDate: '',
                    etimeDate: ''
                },
                dateTime: '',
                serverIds: '',
                isSelectAllServer: true,

                activityDetailData: [],

                serverOthers: [],
                reloadOtherConfigData: [],
                reloadConfigData: [],

            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList,
            }),
        },
        mixins: [paginationController, actionConfirm],
        mounted() {
            this.getReadData();
            this.getNodeAndLoginData();
        },
        methods: {
            getReadData() {
                this.tableHeaders = [];
                confApi.getReadData({
                    token: this.token,
                    tableName: 'activity_config'
                }).then(res => {
                    res.forEach(item => {
                        item.stime = (item.stime!==-1)?Utils.formatDate(new Date(item.stime)):item.stime;
                        item.etime = (item.etime!==-1)?Utils.formatDate(new Date(item.etime)):item.etime;
                    })

                    this.rawData = res;
                    this.totalRow = res.length;

                    this.tableRawData = res;
                    this.tableTotalRow = res.length;
                    for (var i in res[0]) {

                        if (i == 'id') {
                            this.tableHeaders.push({
                                text: i,
                                label: 'id'
                            });
                        } else if (i == 'template_id') {
                            this.tableHeaders.push({
                                text: i,
                                label: '模板id'
                            });
                        } else if (i == 'serverids') {
                            this.tableHeaders.push({
                                text: i,
                                label: '生效的游戏服'
                            });
                        } else if (i == 'switch_flag') {
                            this.tableHeaders.push({
                                text: i,
                                label: '活动操作'
                            });
                        } else if (i == 'stime') {
                            this.tableHeaders.push({
                                text: i,
                                label: '开启时间'
                            });
                        } else if (i == 'etime') {
                            this.tableHeaders.push({
                                text: i,
                                label: '关闭时间'
                            });
                        } else if (i == 'memo_backup') {
                            this.tableHeaders.push({
                                text: i,
                                label: '活动备注'
                            });
                        }
                    }
                })

                confApi.getReadData({
                    token: this.token,
                    tableName: 'activity_template_config'
                }).then(res => {
                    this.activityTemplateData = res;
                })
            },

            handleClick(tab, event) {
                if (tab.name === 'first') {
                    this.getReadData();
                }
            },

            addActivityDialogShow() {
                this.addActivityShow = true;
                this.getReloadConfigData('all');
            },

            confirmAddActivity() {
                var isConfirm = true;
                var data = this.createActivityForm;
                var stime = this.dateTime[0];
                var etime = this.dateTime[1];
                data.stimeDate = stime;
                data.etimeDate = etime;

                if (this.isSelectAllServer) {
                    data.serverids = '0';
                } else {
                    data.serverids = this.serverIds.join(',');
                }

                var currentTemplate = '';

                currentTemplate = this.getMatchTemplate(data.templateId);

                if (currentTemplate == 'UNIQUE_UP') {
                    this.tableRawData.forEach(item => {
                        var templateItem = this.getMatchTemplate(item.template_id);
                        if (Date.parse(item.stime)<=Date.parse(data.stimeDate) && Date.parse(item.etime)>=Date.parse(data.etimeDate) && templateItem == 'BEFALL_UP') {
                            this.$message({
                                type: 'info',
                                message: '当前时间可开启降临up活动，当前活动无法开启'
                            })
                            isConfirm = false;
                        }
                    })
                } else if (currentTemplate == 'BEFALL_UP') {
                    this.tableRawData.forEach(item2 => {
                        var templateItem2 = this.getMatchTemplate(item2.template_id);
                        if (Date.parse(item2.stime)<=Date.parse(data.stimeDate) && Date.parse(item2.etime)>=Date.parse(data.etimeDate) && templateItem2 == 'UNIQUE_UP') {
                            this.$message({
                                type: 'info',
                                message: '当前时间可开启绝版UP活动，当前活动无法开启'
                            })
                            isConfirm = false;
                        }
                    })
                }

                if (isConfirm) {
                    activityApi.saveActivity({
                        createForm: this.createActivityForm,
                        token: this.token
                    }).then(res => {
                        this.addActivityShow = false;
                        this.$message({
                            type: 'success',
                            message: '创建成功'
                        })
                        this.getReadData();
                        if (this.isSelectAllServer) {
                            this.reloadAllAxios();
                        } else {
                            this.reloadAxiosGame(this.serverIds);
                        }
                    })
                }
            },

            activityDetailShow(day) {
                this.activityDetailData = [];
                this.tableRawData.forEach(item => {
                    if (item.stime!== -1 && item.etime!== -1 && Date.parse(item.stime.split(' ')[0]) <= Date.parse(day) && Date.parse(item.etime.split(' ')[0]) >= Date.parse(day)) {
                        this.activityDetailData.push(item)
                    }
                })
            },

            getMatchTemplate(templateId) {
                var template = '';
                this.activityTemplateData.forEach(item => {
                    if (item.id == templateId) {
                        template = item.template;
                    }
                })
                return template;
            },

            // 获取登录服和战斗服数据
            getNodeAndLoginData() {
                let self = this;
                confApi.getReadData({
                    token: self.token,
                    tableName: 'yunwei_server_config'
                }).then(res => {
                    res.forEach(item => {
                        if (item.server_type == 'login' || item.server_type == 'battleValidate') {
                            self.reloadOtherConfigData.push({
                                port_json: item.port_json,
                                uri: item.server_url,
                                type: item.server_type,
                                server_name: item.server_name,
                                resStatus: 0,
                                msg: '未发送',
                                initPort: item.port_proc,
                            })
                        }
                    })
                })
            },

            elChangeExForArray (index1, index2, array) {
                let temp = array[index1]
                array[index1] = array[index2]
                array[index2] = temp
                return array
            },

            getReloadConfigData(type) {
                let self = this;
                self.reloadConfigData = [];

                var data = [];

                if (type == 'world') {
                    self.serverWorldList.forEach(item => {
                        if (self.safeguardWorldId == item.id) {
                            item.type = 'world';
                            data.push(item)
                        }
                    });
                } else if (type == 'all') {
                    self.serverWorldList.forEach(item => {
                        item.type = 'world';
                        data.push(item)
                    });
                }

                data.forEach(item3 => {
                    item3.game_servers.forEach(item4 => {
                        item4.type = 'game';
                        data.push(item4)
                    })
                });

                if (data[0].type !== 'game') {
                    data = this.elChangeExForArray(0,1,data);
                }

                data.forEach(item5 => {
                    self.reloadConfigData.push({
                        description: item5.server_name,
                        serverNumber: item5.server_number,
                        uri: item5.inner_urls.split(';')[0],
                        type: item5.type,
                        resStatus: 0,
                        msg: '未发送'
                    });

                    var balanceIps = item5.inner_urls.split(';');
                    balanceIps.shift();
                    if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                        balanceIps.forEach(item6 => {
                            self.reloadConfigData.push({
                                description: item5.server_name,
                                serverNumber: item5.server_number,
                                uri: item6,
                                type: item5.type,
                                resStatus: 0,
                                msg: '未发送'
                            })
                        });
                    }
                });

            },

            // 重载全部
            reloadAllAxios() {
                let self = this;
                self.reloadOtherConfigData.forEach((otherItem,otherIndex) => {
                    let reloadForm= {};
                    if (otherItem.type == 'login') {
                        reloadForm = {
                            loginUri: otherItem.uri,
                            type: otherItem.type,
                            className: 'ActivityConfig'
                        }

                        loginApi.loginReloadAll({
                            token: this.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            otherItem.resStatus = res.resStatus;

                            let resultArr = [];
                            self.reloadConfigData.forEach((item ,index) => {
                                let reloadForm= {};
                                if (item.type == 'game') {
                                    reloadForm = {
                                        uri: item.uri,
                                        type: item.type,
                                        className: 'ActivityConfig'
                                    }
                                    gameApi.gameReloadAll({
                                        token: this.token,
                                        reloadForm: reloadForm
                                    }).then(res => {
                                        item.resStatus = res.resStatus;
                                        item.msg = res.content.msg;
                                        resultArr.push(item);
                                    })

                                } else if (item.type == 'world') {
                                    reloadForm = {
                                        worldUri: item.uri,
                                        type: item.type,
                                        className: 'ActivityConfig'
                                    }

                                    worldApi.worldReloadAll({
                                        token: this.token,
                                        reloadForm: reloadForm
                                    }).then(res => {
                                        item.resStatus = res.resStatus;
                                        item.msg = res.content.msg;
                                        resultArr.push(item);
                                    })
                                }
                            })
                            self.reloadConfigData = resultArr;
                        })
                    }
                })
            },

            // 重载游戏服
            reloadAxiosGame(data) {
                let self = this;

                self.reloadOtherConfigData.forEach((otherItem,otherIndex) => {
                    let reloadForm= {};
                    if (otherItem.type == 'login') {
                        reloadForm = {
                            loginUri: otherItem.uri,
                            type: otherItem.type,
                            className: 'ActivityConfig'
                        }

                        loginApi.loginReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            otherItem.resStatus = res.resStatus;

                            data.forEach(gameItem => {
                                this.serverGameList.forEach(serverGameItem => {
                                    if (gameItem == serverGameItem.server_number) {
                                        var balanceIps = serverGameItem.inner_urls.split(';');
                                        balanceIps.forEach(item => {
                                            let reloadForm = {};
                                            reloadForm = {
                                                uri: item,
                                                type: 'game',
                                                className: 'ActivityConfig'
                                            }

                                            gameApi.gameReloadConfig({
                                                token: self.token,
                                                reloadForm: reloadForm
                                            }).then(res => {

                                            })
                                        })
                                    }
                                })

                            })
                        })
                    }
                })
            },

            // 重载对应游戏服和世界服
            reloadAxiosGameAndWorld(data) {
                let self = this;
                var reloadConfigData = [];
                data.forEach(gameItem => {
                    self.serverGameList.forEach(serverGameItem => {
                        if (gameItem == serverGameItem.server_number) {
                            reloadConfigData.push({
                                uri: serverGameItem.inner_urls.split(';')[0],
                                type: 'game',
                            })

                            var balanceIps = serverGameItem.inner_urls.split(';');
                            balanceIps.shift();
                            if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                                balanceIps.forEach(balanceIpsItem => {
                                    reloadConfigData.push({
                                        uri: balanceIpsItem,
                                        type: 'game',
                                    })
                                });
                            }
                        }
                        self.serverWorldList.forEach(serverWorldItem => {
                            if (serverWorldItem.id == serverGameItem.world_id) {
                                reloadConfigData.push({
                                    uri: serverWorldItem.inner_urls.split(';')[0],
                                    type: 'world',
                                })

                                var balanceIps = serverWorldItem.inner_urls.split(';');
                                balanceIps.shift();
                                if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                                    balanceIps.forEach(balanceIpsItem => {
                                        reloadConfigData.push({
                                            uri: balanceIpsItem,
                                            type: 'world',
                                        })
                                    });
                                }
                            }
                        })
                    })

                })

                reloadConfigData.forEach(reloadItem => {
                    let reloadForm = {};
                    if (reloadItem.type == 'world') {
                        reloadForm = {
                            worldUri: reloadItem.uri,
                            type: reloadItem.type,
                            className: 'ActivityConfig'
                        }

                        worldApi.worldReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {

                        })
                    } else if (reloadItem.type == 'game') {
                        reloadForm = {
                            uri: reloadItem.uri,
                            type: reloadItem.type,
                            className: 'ActivityConfig'
                        }

                        gameApi.gameReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {

                        })
                    }
                })
            },

            // 重载全部游戏服和世界服
            reloadAxiosALLGameAndWorld() {
                let self = this;
                var reloadConfigData = [];

                self.serverGameList.forEach(serverGameItem => {
                    reloadConfigData.push({
                        uri: serverGameItem.inner_urls.split(';')[0],
                        type: 'game',
                    })

                    var balanceIps = serverGameItem.inner_urls.split(';');
                    balanceIps.shift();
                    if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                        balanceIps.forEach(balanceIpsItem => {
                            reloadConfigData.push({
                                uri: balanceIpsItem,
                                type: 'game',
                            })
                        });
                    }
                })

                self.serverWorldList.forEach(serverWorldItem => {
                    reloadConfigData.push({
                        uri: serverWorldItem.inner_urls.split(';')[0],
                        type: 'world',
                    })

                    var balanceIps = serverWorldItem.inner_urls.split(';');
                    balanceIps.shift();
                    if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                        balanceIps.forEach(balanceIpsItem => {
                            reloadConfigData.push({
                                uri: balanceIpsItem,
                                type: 'world',
                            })
                        });
                    }
                })

                reloadConfigData.forEach(reloadItem => {
                    let reloadForm = {};
                    if (reloadItem.type == 'world') {
                        reloadForm = {
                            worldUri: reloadItem.uri,
                            type: reloadItem.type,
                            className: 'ActivityConfig'
                        }

                        worldApi.worldReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {

                        })
                    } else if (reloadItem.type == 'game') {
                        reloadForm = {
                            uri: reloadItem.uri,
                            type: reloadItem.type,
                            className: 'ActivityConfig'
                        }

                        gameApi.gameReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {

                        })
                    }
                })
            },

            // 开启\关闭活动
            switchFlagActivity(data) {
                var serverData = data.serverids.split(',');
                var self = this;
                var switchFlagForm = {
                    id: data.id,
                    switchFlag: (data.switch_flag == 1)?0:1
                };
                activityApi.switchFlagActivity({
                    token: self.token,
                    switchFlagForm: switchFlagForm
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    })
                    this.getReadData();
                    this.reloadAxiosGame(serverData);
                    if (data.serverids == '0') {
                        // 重载全部
                        this.reloadAxiosALLGameAndWorld();
                    } else {
                        // 重载对应
                        this.reloadAxiosGameAndWorld(serverData);
                    }
                })
            }
        },
    };
</script>

<style lang="less">
    .config_label {
        font-size: 18px;
    }

    .btn-group {
        display: flex;
    }
     .is-selected {
        color: #1989FA;
      }

    .el-calendar-table .el-calendar-day {
        height: auto !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/activity_gift/activity_editor_bak.vue